<template>
  <div>
    <base-header class="pb-6" />
    <b-container fluid class="mt--6 max-width">
      <b-card no-body>

        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">

            <card-header title="Edit Device">
              <base-button type="white" size="sm" @click="onCancel">Cancel</base-button>
              <base-button type="success" size="sm" native-type="submit" :loading="isLoading">Save</base-button>
            </card-header>

            <b-card-body>
              <b-row>
                <b-col md="6">
                  <base-input label="Device ID" name="name" v-model="form.name" disabled />
                </b-col>
                <b-col md="6">
                  <base-input label="Description" name="description" v-model="form.description" />
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <fieldset>
                    <label class="form-control-label">Entity</label>
                    <b-form-select v-model="form.entity" :options="entityOptions" />
                  </fieldset>
                </b-col>
              </b-row>
            </b-card-body>

          </b-form>
        </validation-observer>

      </b-card>
    </b-container>
  </div>
</template>

<script>
import { Routes } from "@/router";
import { Action } from "@/store/actions";
import { mapGetters } from "vuex";

export default {
  name: "SDeviceEdit",
  data() {
    return {
      form: {
        name: '',
        description: '',
        entity: '',
      },
      entityOptions: [],
      originalEntity: '',
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters(['deviceByName', 'getEntities']),
  },
  methods: {
    onCancel() {
      this.$router.push({ name: Routes.sDevicesList });
    },
    async onSubmit() {
     // console.log('[SDeviceEdit] onSubmit called');
      this.isLoading = true;
      try {
      //  console.log('[SDeviceEdit] form.entity:', this.form.entity, 'originalEntity:', this.originalEntity);
        if (this.form.entity !== this.originalEntity) {
         // console.log('[SDeviceEdit] Calling move API directly...');
          const response = await this.$http.post(`/device/${this.form.name}/move`, {
            entity: this.form.entity,
          });
         // console.log('[SDeviceEdit] move response:', response.data);
        } else {
         // console.log('[SDeviceEdit] Updating description via direct PUT...');
          await this.$http.put(`/tenant/${this.originalEntity}/device/${this.form.name}`, {
            operator: { $set: { description: this.form.description } },
          });
        //  console.log('[SDeviceEdit] description updated');
        }
        this.$notify({ title: 'Success', message: 'Device updated', type: 'success' });
        this.$router.push({ name: Routes.sDevicesList });
      } catch (error) {
        console.error('[SDeviceEdit] onSubmit error:', error);
        this.isLoading = false;
        this.$notify({ title: 'Error', message: error?.errorInfo?.userMessage || error?.message || 'Update failed', type: 'error' });
      }
    },
  },
  async mounted() {
    const name = this.$route.params.name;
    const device = this.deviceByName(name);
    if (!device) {
      this.$router.back();
      return;
    }
    this.form.name = device.name;
    this.form.description = device.description || '';
    this.form.entity = device.entity || '';
    this.originalEntity = device.entity || '';

    // Use cached entities if already loaded, otherwise fetch
    let entities = this.getEntities || [];
    if (!entities.length) {
      try {
        await this.$store.dispatch(Action.landlord.loadEntities);
        entities = this.getEntities || [];
      } catch (e) {
        console.error('Failed to load entities', e);
      }
    }
    this.entityOptions = entities.map(e => ({ value: e.name, text: e.name }));
  },
};
</script>
